import React from 'react';
import CallToAction from './CTA';
import DownloadApp from './DownloadApp';
import FeaturesSection from './Features';
import HeroSection from './Hero';
import TestimonialsSection from './Testimonials';
import { SnackbarProvider } from 'notistack';

const LandingCooperationColumn = ({ logo, name, discount, referralCode }) => {
  return (
    <SnackbarProvider>

      <HeroSection
        logo={logo}
        name={name}
        discount={discount}
        referralCode={referralCode}
      />
      <FeaturesSection name={name} cooperation discount={discount} />
      <TestimonialsSection />
      <DownloadApp />
      <CallToAction
        text={
          'الدروس الخصوصية تعتبر أسرع طريقة لزيادة تحصيل ابنائك الدراسية فساهم في اعدادهم للمستقبل عن طريق تدريسهم'
        }
      />
    </SnackbarProvider>
  );
};

export default LandingCooperationColumn;
